export const SignatureDimensionsCollection: Record<
  string,
  Record<string, SignatureDimensions>
> = {
  "c2530014935c4d9d94d0e633b291ec50": {
    1: {
      baseLinePixelsPerModule: 2,
      rectWidth: 450,
      rectHeight: 108,
      offsetX: 588,
      offsetY: 743,
    },
  },
  "f7a9c3e2b6d84f4e9c2a1d7b8e5f3a6c": {
    2: {
      baseLinePixelsPerModule: 2,
      rectWidth: 440,
      rectHeight: 103,
      offsetX: 568,
      offsetY: 783,
    },
  },
  "467e58cfdcc981878c60b74de9e9d0f5": {
    3: {
      baseLinePixelsPerModule: 3.2,
      rectWidth: 440,
      rectHeight: 108,
      offsetX: 565,
      offsetY: 786,
    }
  }
};

export interface DataMatrixMetadata {
  id: string; // Unique id from Data Matrix
  version: string; // Version of the signature dimensions
  height: number; // Height of the Data Matrix in modules
  width: number; // Width of the Data Matrix in modules
};

export interface DataMatrixScanResult {
  base64Data : string;
  hasDataMatrix : boolean;
}

export interface SignatureDimensions {
  /**
   * Reference pixels per Data Matrix module used for scaling calculations.
   * Data Matrix codes are composed of square modules, and this baseline value
   * represents the expected pixel size of each module in the reference image.
   * Used to calculate scale ratios when the actual Data Matrix size differs
   * from the baseline, ensuring signature positioning scales proportionally.
   */
  baseLinePixelsPerModule: number;
  rectWidth: number; // Width of the signature rectangle in pixels
  rectHeight: number; // Height of the signature rectangle in pixels
  offsetX: number; // X offset from the Data Matrix top-left corner
  offsetY: number; // Y offset from the Data Matrix top-left corner
}

/**
 * Converts base64 string to Blob
 * @param base64 - Base64 encoded string (without data URI prefix)
 * @param mimeType - MIME type of the blob (e.g., 'image/png')
 * @returns Blob object
 */
export function base64ToBlob(base64: string, mimeType: string): Blob {
  // Remove data URI prefix if present
  const base64Data = base64.includes(",") ? base64.split(",")[1] : base64;

  // Decode base64 string
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
}

/**
 * Converts an ArrayBuffer to Base64 encoded string
 * @param fileData - ArrayBuffer of the file to be converted to Base64
 * @description Converts an ArrayBuffer to a Base64 encoded string.
 * @returns Base64 encoded string
 */
export function convertArrayBufferToBase64(fileData: ArrayBuffer): string {
  const bytes = new Uint8Array(fileData);

  let binary = "";
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }

  return globalThis.btoa(binary);
}
